

// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// お問い合わせオンリーの馬

setTimeout(function() {
  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝以下の１行だけ　を編集してください！！！＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   const horses = ["ヤエノグラフ21","プライムウィッシュ21","レディストレイツ21"];
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
  
  horses.forEach(horse => {
    if (document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none") != null) {
      document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none").style.display = "none";
      document.querySelector("#" + horse + " .product__tab.tab").style.display = "none";
      document.querySelector("#" + horse + " .product__price-container").style.display = "none";

      const newElement = document.createElement("a");
      const newContent = document.createTextNode("お問い合わせをする");
      newElement.appendChild(newContent);
      newElement.setAttribute("class","inquiry-only-btn");
      newElement.setAttribute("href","https://umauma-shop.com/pages/contact");
      const newElement2 = document.createElement("p");
      const newContent2 = document.createTextNode("この競走馬は、お問い合わせのみでの取り扱いでございます。ご興味のある方は「お問い合わせをする」ボタンより、ご連絡くださいませ。");
      newElement2.appendChild(newContent2);
      newElement2.setAttribute("class","inquiry-only-introduction");

      const parent_container = document.querySelector("#" + horse + " .product__info-container");
      const child_content = document.querySelector("#" + horse + " .product__content");
      parent_container.insertBefore(newElement2, child_content);
      parent_container.insertBefore(newElement, child_content);
    }
  });
}, 300);





// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// セレクションセールに出る予定の馬

setTimeout(function() {
  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝以下の１行だけ　を編集してください！！！＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
  const horses = ["ヤエノグラフ21","クイーンズシアター21","アドマイヤエバート21"];
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
  
  horses.forEach(horse => {
    if (document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none") != null) {
      document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none").style.display = "none";
      document.querySelector("#" + horse + " .product__tab.tab").style.display = "none";
      document.querySelector("#" + horse + " .product__price-container").style.display = "none";

      const newElement = document.createElement("a");
      const newContent = document.createTextNode("お問い合わせをする");
      newElement.appendChild(newContent);
      newElement.setAttribute("class","inquiry-only-btn");
      newElement.setAttribute("href","https://umauma-shop.com/pages/contact");
      const newElement2 = document.createElement("p");
      const newContent2 = document.createTextNode("本馬は、セレクションセール上場予定のため、お問い合わせのみでの取り扱いとなります。");
      newElement2.appendChild(newContent2);
      newElement2.setAttribute("class","inquiry-only-introduction");

      const parent_container = document.querySelector("#" + horse + " .product__info-container");
      const child_content = document.querySelector("#" + horse + " .product__content");
      parent_container.insertBefore(newElement2, child_content);
      parent_container.insertBefore(newElement, child_content);
    }
  });
}, 300);



// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// サマーセールに出る予定の馬

setTimeout(function() {
  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝以下の１行だけ　を編集してください！！！＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
   const horses = ["アイラインローザー21","ユーアーマイン21","スイートリリック21","プライムウィッシュ21","カリビアンセレブ21","ドナジュディス21","ミヤビソーダライト21","マイネフォクシー21","ファブラノヴァ21","ムーンフライト21","マーティンオート21","ジャンニーナ21","リラックススマイル21","トップレイスター21","キョウワエステル21","トモトモリバー21","レヴリ21","パチュリー21",""];
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
  
  horses.forEach(horse => {
    if (document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none") != null) {
      document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none").style.display = "none";
      document.querySelector("#" + horse + " .product__tab.tab").style.display = "none";
      document.querySelector("#" + horse + " .product__price-container").style.display = "none";

      const newElement = document.createElement("a");
      const newContent = document.createTextNode("お問い合わせをする");
      newElement.appendChild(newContent);
      newElement.setAttribute("class","inquiry-only-btn");
      newElement.setAttribute("href","https://umauma-shop.com/pages/contact");
      const newElement2 = document.createElement("p");
      const newContent2 = document.createTextNode("本馬は、サマーセール上場予定のため、お問い合わせのみでの取り扱いとなります。");
      newElement2.appendChild(newContent2);
      newElement2.setAttribute("class","inquiry-only-introduction");

      const parent_container = document.querySelector("#" + horse + " .product__info-container");
      const child_content = document.querySelector("#" + horse + " .product__content");
      parent_container.insertBefore(newElement2, child_content);
      parent_container.insertBefore(newElement, child_content);
    }
  });
}, 300);




// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// ＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋＋
// 共有馬

setTimeout(function() {
  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝以下の１行だけ　を編集してください！！！＝＝＝＝＝＝＝＝＝
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
   const horses = ["チェリーエンジェル21"];
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
//   ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝  
  
  horses.forEach(horse => {
    if (document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none") != null) {
      document.querySelector("#" + horse + " .product__form.product-form.product__block--border-none").style.display = "none";
      document.querySelector("#" + horse + " .product__tab.tab").style.display = "none";
      document.querySelector("#" + horse + " .product__price-container").style.display = "none";

      const newElement = document.createElement("a");
      const newContent = document.createTextNode("お問い合わせをする");
      newElement.appendChild(newContent);
      newElement.setAttribute("class","inquiry-only-btn");
      newElement.setAttribute("href","https://umauma-shop.com/pages/contact");
      const newElement2 = document.createElement("p");
      const newContent2 = document.createTextNode("本馬は共有馬のため、お問い合わせのみでの取り扱いとなります。1/10での販売価格は80万円(税込み88万円)となります。");
      newElement2.appendChild(newContent2);
      newElement2.setAttribute("class","inquiry-only-introduction");

      const parent_container = document.querySelector("#" + horse + " .product__info-container");
      const child_content = document.querySelector("#" + horse + " .product__content");
      parent_container.insertBefore(newElement2, child_content);
      parent_container.insertBefore(newElement, child_content);
    }
  });
}, 300);

